import React from "react";
import Item from "~/components/miniComponent/item/Item";
import "./BestSeller.scss";

function BestSeller() {
  return (
    <div className="my-5">
      <div className="sub-title-heading">Tháng này</div>
      <div className="heading">
        <h3 className="title-heading">
          <a href="/">Sản Phẩm Bán Chạy</a>
        </h3>
      </div>
      <div className="slider-best-selling">
        <Item></Item>
        <Item></Item>
        <Item></Item>
        <Item></Item>
        <Item></Item>
        <Item></Item>
        <Item></Item>
        <Item></Item>
      </div>
      <button className="cus-btn button-container view-all">Xem Tất Cả</button>
    </div>
  );
}

export default BestSeller;
